import React from "react";
import Fab from "@material-ui/core/Fab/Fab";
import { withRouter } from 'react-router-dom';
import style from "./style";
import {connect} from "react-redux";
import {setBecomeChef, setIsChef} from "../../redux/auth";

function DinerButton (props) {
  const handleContinueDiner = () => {
    const { dispatch } = props;

    dispatch(setBecomeChef(false));
    dispatch(setIsChef(false));
    props.history.push('/home/dashboard');
  }

  return (
    <Fab
      data-test-id={"continueasdin"}
      variant={"extended"}
      type="button"
      style={{ display: 'none' }}
      onClick={handleContinueDiner}
    >
      Continue as diner
    </Fab>
  );
}

function mapStatetoProps(state) {
  return {};
}

const ContinueAsDiner = connect(mapStatetoProps)(withRouter(DinerButton));

export default ContinueAsDiner;
